<template>
	<div class="main-menu">
		<template v-for="item in menuItems">
			<router-link v-if="item == 'dashboard'" :key="item" class="list-item" :to="{name: 'dashboard'}">
				{{ t.mainMenuHome }}
			</router-link>

			<router-link v-if="item == 'history'" :key="item" class="list-item" :to="{name: 'history'}">
				{{ t.mainMenuHistory }}
			</router-link>

			<router-link v-if="item == 'prizes'" :key="item" class="list-item" :to="{name: 'prizes'}">
				{{ t.mainMenuRewards }}
			</router-link>

			<router-link v-if="item == 'profile'" :key="item" class="list-item" :to="{name: 'profile'}">
				{{ t.mainMenuProfile }}
			</router-link>

			<router-link v-if="item == 'help'" :key="item" class="list-item" :to="{name: 'help'}">
				{{ t.mainMenuHelp }}
			</router-link>

			<router-link v-if="item == 'news' && settings.newsEnabled" :key="item" class="list-item" :to="{name: 'news'}" style="position: relative">
				{{ t.mainMenuNews }}
				<span v-if="newsState.unreadCount > 0" class="badge-notification">{{ newsState.unreadCount }} </span>
			</router-link>
		</template>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user';
import { useNewsStore } from '@/js/stores/news';

const store = useStore()
const userStore = useUserStore()
const newsStore = useNewsStore()

// Computeds
const t = computed(() => store.translations)
const settings = computed(() => store.settings)
const newsState = computed(() => newsStore)
const menuItems = computed(() => store.isMobile ? store.settings.ui.mainMenuOrderMobile : store.settings.ui.mainMenuOrderDesktop)
</script>